var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.92451C21.263 6.24974 20.4723 6.47054 19.6428 6.569C20.4902 6.06176 21.1407 5.25615 21.445 4.29837C20.6514 4.7698 19.7741 5.10995 18.8402 5.29494C18.0913 4.49828 17.0261 4 15.8445 4C13.5799 4 11.7419 5.83798 11.7419 8.10264C11.7419 8.42488 11.7777 8.73818 11.8493 9.03655C8.43891 8.86648 5.41638 7.23139 3.39341 4.74892C3.04132 5.35462 2.83843 6.05878 2.83843 6.81068C2.83843 8.23392 3.56348 9.49008 4.66448 10.2241C3.99314 10.2032 3.36058 10.0182 2.80561 9.71088C2.80561 9.72878 2.80561 9.7437 2.80561 9.7616C2.80561 11.7488 4.2199 13.4077 6.09667 13.7837C5.75354 13.8762 5.38953 13.9269 5.01656 13.9269C4.75101 13.9269 4.49441 13.9 4.24377 13.8523C4.76593 15.4814 6.28166 16.669 8.07489 16.7018C6.66955 17.8028 4.90318 18.4592 2.97867 18.4592C2.64747 18.4592 2.32224 18.4383 2 18.4025C3.81411 19.5662 5.97136 20.2465 8.28972 20.2465C15.8356 20.2465 19.9621 13.9955 19.9621 8.57407C19.9621 8.39505 19.9591 8.21901 19.9502 8.04297C20.7528 7.46412 21.448 6.74206 21.997 5.91854L22 5.92451Z",
    fill: "#B5BEED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.b07dd1fdbb829688aee0167fa72a6dc6.svg";
export { ForwardRef as ReactComponent };